var exports = {
  "LL": "LexicalMessageComposer.module__editable___bzk5d2",
  "h5": "LexicalMessageComposer.module__richInputHost___bzk5d2",
  "I8": "LexicalMessageComposer.module__formSize___bzk5d2",
  "FY": "LexicalMessageComposer.module__paragraph___bzk5d2",
  "qf": "LexicalMessageComposer.module__placeholder___bzk5d2",
  "xL": "LexicalMessageComposer.module__marker___bzk5d2",
  "_u": "LexicalMessageComposer.module__blockquoteLine___bzk5d2",
  "iU": "LexicalMessageComposer.module__blockquoteMarker___bzk5d2",
  "Cr": "LexicalMessageComposer.module__bold___bzk5d2",
  "TN": "LexicalMessageComposer.module__italic___bzk5d2",
  "V1": "LexicalMessageComposer.module__underline___bzk5d2",
  "ZN": "LexicalMessageComposer.module__strike___bzk5d2",
  "aY": "LexicalMessageComposer.module__code___bzk5d2",
  "Po": "LexicalMessageComposer.module__mentionHost___bzk5d2",
  "ZJ": "LexicalMessageComposer.module__emojiHost___bzk5d2",
  "G5": "LexicalMessageComposer.module__command___bzk5d2",
  "Gx": "LexicalMessageComposer.module__slashSlot___bzk5d2",
  "Pe": "LexicalMessageComposer.module__slashSlotPlaceholder___bzk5d2",
  "ZW": "LexicalMessageComposer.module__slashSlotSeparator___bzk5d2",
  "Q$": "LexicalMessageComposer.module__optionalHint___bzk5d2",
};

module.exports = exports;
